export default "__VITE_ASSET__9d1a40db__"